// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { paymentTermSchema } from '@/payment-term/api/types';
import { sparseCustomerSchema, sparseProjectSchema } from '@/sparse/api/types';
import { dateSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

// CustomerAutocomplete only reads id/name/isArchived/isCustomer/isSupplier,
// so the form stores customers in the sparse shape — that lets the picker
// accept either a full Customer (from the customers listing) or the
// SparseCustomer carried on a project, without a lookup roundtrip.
export const addInvoiceFormSchema = z
  .object({
    customer: sparseCustomerSchema.nullable(),
    project: sparseProjectSchema.nullable(),
    invoiceDate: dateSchema,
    dueDate: dateSchema.nullable(),
    paymentTerm: paymentTermSchema.nullable(),
    purchaseOrderNumber: z.string(),
  })
  .refine((value) => value.customer !== null, {
    message: 'Customer is required',
    path: ['customer'],
  })
  .refine((value) => value.project !== null, {
    message: 'Project is required',
    path: ['project'],
  })
  .refine((value) => value.dueDate !== null, {
    message: 'Due date is required',
    path: ['dueDate'],
  })
  .refine(
    (value) => value.dueDate === null || value.dueDate >= value.invoiceDate,
    {
      message: 'Due date must not be before invoice date',
      path: ['dueDate'],
    }
  );

export type AddInvoiceFormData = z.infer<typeof addInvoiceFormSchema>;
